export type SelectPart = {
  default: string;
  hover: string;
  focus: string;
  disabled: string;
};

export const selectStates = {
  default: {
    glow: 'bg-[#0DB4FD]',
    bg: {
      default: 'bg-white/[0.05]',
      hover: 'peer-hover/field:bg-white/[0.08]',
      focus: 'peer-focus-visible/field:bg-white/[0.08]',
      disabled:
        'bg-gradient-to-b group-disabled/input:from-white/20 group-disabled/input:to-white/10',
    },
    border: {
      default: 'bg-gradient-to-b from-white/30 to-white/10',
      hover: '',
      focus:
        'peer-focus-visible/field:from-white peer-focus-visible/field:to-white',
      disabled: '',
    },
  },
  success: {
    glow: 'bg-[#00EE7E]',
    bg: {
      default: 'bg-white/[0.05]',
      hover: 'peer-hover/field:bg-white/[0.08]',
      focus: 'peer-focus-visible/field:bg-white/[0.08]',
      disabled:
        'bg-gradient-to-b group-disabled/input:from-white/20 group-disabled/input:to-white/10',
    },
    border: {
      default: 'bg-gradient-to-b from-bionic-green/50 to-bionic-green/20',
      hover: '',
      focus:
        'peer-focus-visible/field:from-white peer-focus-visible/field:to-white',
      disabled: '',
    },
  },
  error: {
    glow: 'bg-[#FC3838]',
    bg: {
      default: 'bg-white/[0.05]',
      hover: 'peer-hover/field:bg-white/[0.08]',
      focus: 'peer-focus-visible/field:bg-white/8',
      disabled:
        'bg-gradient-to-b group-disabled/input:from-white/20 group-disabled/input:to-white/10',
    },
    border: {
      default: 'bg-gradient-to-b from-[#FC3838]/50 to-[#FC3838]/20',
      hover: '',
      focus:
        'peer-focus-visible/field:from-white peer-focus-visible/field:to-white',
      disabled: '',
    },
  },
};
